<template>
	<div class="mainBox">
		<div class="topNav">
			<van-nav-bar :fixed="true" :placeholder="true" title="记事列表" left-text="返回" left-arrow @click-left="goBack">
				<template #right>
					<div class="rightRoundBox" v-if="showAdd" @click="toAdd">
						<img class="addSomeDay" src="../../assets/images/addSomeDay.png"/>
					</div>
				</template>
			</van-nav-bar>
		</div>
		<!-- 下拉刷洗 -->
		<van-pull-refresh v-model="isRefreshLoading" success-text="刷新成功" @refresh="onRefresh">
			<van-list
			v-model="loading"
			:finished="finished"
			finished-text="没有更多了"
			@load="loadMore"
			>
				<div class="notesList" v-for="item in dataList" @click="goDetail(item.dailyId)">
					<van-row gutter="20" class="notesTop">
						<van-col span="6" style="white-space: nowrap;">{{item.recTime}}</van-col>
						<van-col span="8" align="center">{{item.recMan}}</van-col>
						<van-col span="10" align="right">
							<div class="weather">{{item.weather}}&nbsp;{{item.temperature}}</div>
							<van-button v-if="showEdit" class="editBtn" type="info" size="mini" @click.stop="goEdit(item.dailyId)">编辑</van-button>
						</van-col>
					</van-row>
					<p class="notes" style="white-space: pre-wrap;">{{item.recContent}}</p>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>
<script>
	import { noteList } from '@/api/notes';
	import common from '../../utils/common';
	import { Notify } from 'vant';

	export default {
		name: 'notesList',
		data() {
			return {
				loading: false,
				finished: false,
				isRefreshLoading: false,
				error: false,
				page: 0,
				limit: 10,
				workNo: "",
				dataList: [],
				showAdd: false,
				showEdit: false,
			}
		},
		mounted() {
			const project = common.getProject();
			if (project != null || project != ""){
				this.workNo = project.workNo;
			}
			if (common.hasPermision("noteList:add")) {
				this.showAdd = true;
			}
			if (common.hasPermision("noteList:edit")) {
				this.showEdit = true;
			}
		},
		methods: {
			goBack() {
				this.$router.push({
					name: 'workbench'
				});
			},
			toAdd(){
				if (!common.hasPermision("noteList:add")) {
					Notify({ type: 'danger', message: "无操作权限" });
					return;
				}
				this.$router.push({
					name: 'notesAdd',
				});
			},
			goEdit(id){
				if (!common.hasPermision("noteList:edit")) {
					Notify({ type: 'danger', message: "无操作权限" });
					return;
				}
				this.$router.push({
					name: 'notesEdit',
					query: {"id": id}
				});
			},
			goDetail(id){
				if (!common.hasPermision("noteList:search")) {
					Notify({ type: 'danger', message: "无操作权限" });
					return;
				}
				this.$router.push({
					name: 'notesDetail',
					query: {"id": id}
				});
			},
			onRefresh(){
				this.finished = false;
				this.loading = true;
				this.page = 1;
				this.dataList = [];
				this.onLoad();
			},
			loadMore(){
				this.page += 1;//页数+1
      			this.onLoad();
			},
			onLoad(){
				let data = {
					page: this.page,
					limit: this.limit,
					workNo: this.workNo
				}
				if (this.isRefreshLoading){
					data.page = 1;
					this.dataList = [];
					this.isRefreshLoading = false;
				}
				noteList(data).then(response => {
					this.loading = false;
					if (response.data.resultCode === 200){
						this.dataList = this.dataList.concat(response.data.body.records);
						if (response.data.body.records.length === 0) {
							this.finished = true;
						}
					}else{
						this.finished = true;
					}
				})
			}
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>